import { type TInboxMessagesStoreName, type TKeyValueStoreName, type TMainLogStoreName, type TMessageLogStoreName } from '../Storage.types';

export const STORE_NAME_KEY_VALUE: TKeyValueStoreName = 'keyValue';
export const STORE_NAME_MESSAGE_LOG: TMessageLogStoreName = 'messages';
export const STORE_NAME_MAIN_LOG: TMainLogStoreName = 'log';
export const STORE_NAME_INBOX_MESSAGES: TInboxMessagesStoreName = 'inboxMessages';

export const KEY_PATH_BASE_INCREMENT = 'id';
